var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "vacancy-details mb-160" }, [
    _c("div", { staticClass: "vacancy-details__top-banner" }, [
      _c("div", { staticClass: "vacancy-details__tags tags" }, [
        _vm.vacancy.city
          ? _c("div", { staticClass: "tags__tag" }, [
              _c("div", [
                _c(
                  "svg",
                  {
                    attrs: {
                      width: "24",
                      height: "24",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg",
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        d: "M18.364 17.3639L12 23.7279L5.636 17.3639C4.37734 16.1052 3.52019 14.5016 3.17293 12.7558C2.82567 11.0099 3.00391 9.20035 3.6851 7.55582C4.36629 5.91129 5.51984 4.50569 6.99988 3.51677C8.47992 2.52784 10.22 2 12 2C13.78 2 15.5201 2.52784 17.0001 3.51677C18.4802 4.50569 19.6337 5.91129 20.3149 7.55582C20.9961 9.20035 21.1743 11.0099 20.8271 12.7558C20.4798 14.5016 19.6227 16.1052 18.364 17.3639ZM12 14.9999C13.0609 14.9999 14.0783 14.5785 14.8284 13.8283C15.5786 13.0782 16 12.0608 16 10.9999C16 9.93906 15.5786 8.92164 14.8284 8.17149C14.0783 7.42135 13.0609 6.99992 12 6.99992C10.9391 6.99992 9.92172 7.42135 9.17158 8.17149C8.42143 8.92164 8 9.93906 8 10.9999C8 12.0608 8.42143 13.0782 9.17158 13.8283C9.92172 14.5785 10.9391 14.9999 12 14.9999ZM12 12.9999C11.4696 12.9999 10.9609 12.7892 10.5858 12.4141C10.2107 12.0391 10 11.5304 10 10.9999C10 10.4695 10.2107 9.96078 10.5858 9.58571C10.9609 9.21064 11.4696 8.99992 12 8.99992C12.5304 8.99992 13.0391 9.21064 13.4142 9.58571C13.7893 9.96078 14 10.4695 14 10.9999C14 11.5304 13.7893 12.0391 13.4142 12.4141C13.0391 12.7892 12.5304 12.9999 12 12.9999Z",
                        fill: "#FA4237",
                      },
                    }),
                  ]
                ),
              ]),
              _vm._v(
                "\n                " +
                  _vm._s(_vm.vacancy.city) +
                  "\n            "
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.vacancy.experience
          ? _c("div", { staticClass: "tags__tag" }, [
              _c("div", [
                _c(
                  "svg",
                  {
                    attrs: {
                      width: "24",
                      height: "24",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg",
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        d: "M15 3C15.552 3 16 3.448 16 4V6H21C21.552 6 22 6.448 22 7V20C22 20.552 21.552 21 21 21H3C2.448 21 2 20.552 2 20V7C2 6.448 2.448 6 3 6H8V4C8 3.448 8.448 3 9 3H15ZM8 8H6V19H8V8ZM18 8H16V19H18V8ZM14 5H10V6H14V5Z",
                        fill: "#FA4237",
                      },
                    }),
                  ]
                ),
              ]),
              _vm._v(
                "\n                " +
                  _vm._s(_vm.vacancy.experience) +
                  "\n            "
              ),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("h1", { staticClass: "vacancy-details__position" }, [
        _vm._v(_vm._s(_vm.vacancy.position)),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "vacancy-details__skills skills" },
        _vm._l(_vm.vacancy.skills, function (skill) {
          return _c("div", { staticClass: "skills__skill" }, [
            _vm._v(_vm._s(skill)),
          ])
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "px-30 py-5 btn-red w-mc  h-mc ",
          attrs: {
            href: "javascript:void(0)",
            onclick: "scrollOnBlock(formNew)",
          },
        },
        [_vm._v("Откликнуться")]
      ),
    ]),
    _vm._v(" "),
    _vm.vacancy.text
      ? _c("h2", { staticClass: "vacancy-details__text" }, [
          _vm._v(_vm._s(_vm.vacancy.text)),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "vacancy-details__desc" },
      _vm._l(_vm.vacancy.info, function (list) {
        return _c(
          "div",
          { staticClass: "vacancy-details__list mb-8" },
          [
            _c("h3", [_vm._v(_vm._s(list.title))]),
            _vm._v(" "),
            _vm._l(list.list, function (items) {
              return _c("ul", [_c("li", [_vm._v(_vm._s(items))])])
            }),
          ],
          2
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }